import React, { useState } from 'react';
import { FiChevronDown } from "react-icons/fi";
import { FiChevronUp } from "react-icons/fi";

function Dropdown({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      <div
        onClick={toggleDropdown}
        className="flex justify-between items-center p-4 border-t-[1px] cursor-pointer"
      >
        <span className='font-primaryFont font-semibold text-sm uppercase tracking-[2px]'>{title}</span>
        <span>{isOpen ?  <FiChevronUp/>: <FiChevronDown/>}</span>
      </div>
      {isOpen && (
        <div className={`px-4 w-full ${isOpen ? 'block'  : 'hidden'} `} style={{ animation: `${isOpen ? 'fadeInHeight 1s ease-in-out forwards' : 'fadeOutHeight 1s ease-in-out reverse'}` }}>
  <ul >
            {children}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Dropdown;
